export const SET_ABOUT_PAGE = "setAboutPage";
